import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import QuizzesCard from "./QuizzesCard";
import QuizzesFilters from "./QuizzesFilters";
import QuizzesQuickActions from "./QuizzesQuickActions";
import { getQuizTestsList } from "../../../actions";
import "./style.scss";
import Loader from "../../../../../shared_components/Loader";
import QuizzesHeroSection from "./QuizzesHeroSection";
import Pagination from "../../../../ReusableComponent/Pagination";

const dropdownItems = [
  { icon: "🔥", label: "Most Popular", link: "#" },
  { icon: "⭐", label: "Highest Rated", link: "#" },
  { icon: "⏱️", label: "Duration", link: "#" },
  { icon: "🆕", label: "Newest", link: "#" },
];

const QuizzesLibrary = () => {
  const dispatch = useDispatch();
  const { quizTestsList, quizTestsListLoading } = useSelector(
    (state) => state.quizTest
  );

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  console.log("Quiz Tests List:", quizTestsList);

  useEffect(() => {
    dispatch(getQuizTestsList({ limit: itemsPerPage, page: currentPage }));
  }, [dispatch, currentPage]);

  const filteredQuizzes = quizTestsList
    ?.filter(
      (data) => data?.quizQuestions?.length > 0 && data?.status === "public"
    )
    ?.sort((a, b) => {
      if (a.isAttempted === b.isAttempted) return 0;
      return a.isAttempted ? 1 : -1;
    });

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  console.log("Total Pages:", quizTestsList?.totalPages);
  const paginatedQuizzes = filteredQuizzes?.slice(
    startIndex,
    endIndex
  );

  return (
    <>
      <div className="row mx-0 d-flex justify-content-center align-items-center">
        <div className="col-12 px-0 mb-5">
          <QuizzesHeroSection />
        </div>
        <div className="col-md-11 col-12">
          <QuizzesFilters />
          {quizTestsListLoading ? (
            <Loader />
          ) : (
            <div className="mx-md-5 mx-3">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h3 className="text-white fw-bold">
                  {/* {
                    quizTestsList.filter(
                      (data) => data?.quizQuestions?.length > 0
                    ).length
                  }{" "} */}{" "}
                  {filteredQuizzes?.length} Quizzes Found
                </h3>
                <div className="dropdown position-relative">
                  <button
                    className="btn dropdown-toggle-quizzes"
                    data-bs-toggle="dropdown"
                  >
                    📊 Sort By
                  </button>
                  <ul className="dropdown-menu">
                    {dropdownItems.map((item, idx) => (
                      <li key={idx}>
                        <Link
                          className="dropdown-item text-white"
                          to={item.link}
                        >
                          {item.icon} {item.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="row mx-0">
                {/* {quizTestsList
                  .filter(
                    (data) =>
                      data?.quizQuestions?.length > 0 &&
                      data?.status === "public"
                  )
                  .sort((a, b) => {
                    if (a.isAttempted === b.isAttempted) return 0;
                    return a.isAttempted ? 1 : -1;
                  })
                  .map((item, index) => {
                    return <QuizzesCard item={item} index={index} />;
                  })} */}
                {paginatedQuizzes?.map((item, index) => (
                  <QuizzesCard key={item._id} item={item} index={index} />
                ))}
              </div>
                <Pagination
                // totalItems={filteredQuizzes?.length}
                // itemsPerPage={itemsPerPage}
                totalPages={quizTestsList?.totalPages}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
              /> 
            </div>
          )}
          <QuizzesQuickActions />
        </div>
      </div>
    </>
  );
};
export default QuizzesLibrary;
